import { services } from '@utils/common-services'

export default [
  {
    path: '/',
    name: 'login',
    component: () => import('@views/TheLogin'),

    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (services.getAuth()) {
          //  services.setDefaultHeaders(services.getAuth())
          if (services.decodeJWT(services.getAuth()).is_staff)
            next({ name: 'dashboard' })
          else next({ name: 'welcome' })
        } else {
          //* /
          // Continue to the login page

          next()
        }
      },
    },
  },

  {
    path: '/home',

    name: 'home',
    component: () => lazyLoadView(import('@views/TheHome')),

    meta: {
      // authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (services.getAuth())
          if (!services.authorized()) next()
          else next({ name: 'session-out' })
        // next()
        else next({ name: 'logout' })
      },
    },

    children: [
      {
        path: '/applicants/',
        name: 'applicants',
        component: () => lazyLoadView(import('@views/staff/TheCandidate')),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            if (services.getAuth())
              if (!services.authorized())
                if (services.decodeJWT(services.getAuth()).is_staff) next()
                else next({ name: '404' })
              else next({ name: 'session-out' })
            // next()
            else next({ name: 'logout' })
          },
        },
      },
      {
        path: '/app-settings/roles-and-permissions',
        name: 'roles-and-permissions',
        component: () => import('@views/staff/TheRolesAndPermissions'),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            if (services.getAuth())
              if (!services.authorized())
                if (services.decodeJWT(services.getAuth()).is_staff) next()
                else next({ name: '404' })
              else next({ name: 'session-out' })
            // next()
            else next({ name: 'logout' })
          },
        },
      },
      {
        path: '/staff-management',
        name: 'staff-management',
        component: () =>
          lazyLoadView(import('@views/staff/TheStaffManagement')),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            if (services.getAuth())
              if (!services.authorized())
                if (services.decodeJWT(services.getAuth()).is_staff) next()
                else next({ name: '404' })
              else next({ name: 'session-out' })
            // next()
            else next({ name: 'logout' })
          },
        },
      },
      {
        path: '/404',
        name: '404',
        component: require('@views/_404').default,
        // Allows props to be passed to the 404 page through route
        // params, such as `resource` to define what wasn't found.
        props: true,
      },
      {
        path: '/forms/:id',

        name: 'form',
        component: () => import('@views/TheForm'),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            if (services.getAuth())
              if (!services.authorized()) next()
              else next({ name: 'session-out' })
            // next()
            else next({ name: 'logout' })
          },
        },
      },
      {
        path: '/forms/:id',

        name: 'applicant-form',
        component: () => import('@views/TheForm'),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            if (services.getAuth())
              if (!services.authorized()) next()
              else next({ name: 'session-out' })
            // next()
            else next({ name: 'logout' })
          },
        },
      },
      {
        path: '/profile-settings',

        name: 'profile-settings',
        component: () => import('@views/TheSettings'),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            if (services.getAuth())
              if (!services.authorized()) next()
              else next({ name: 'session-out' })
            // next()
            else next({ name: 'logout' })
          },
        },
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => lazyLoadView(import('@views/TheDashboard')),

        meta: {
          title: 'Dashboard',
          meta: [{ name: 'description', content: `Dashboard FC Form` }],
          beforeResolve(routeTo, routeFrom, next) {
            if (services.getAuth())
              if (!services.authorized()) next()
              else next({ name: 'session-out' })
            // next()
            else next({ name: 'logout' })
          },
        },
      },
      {
        path: '/welcome',
        name: 'welcome',
        component: () => lazyLoadView(import('@views/TheDashboard')),
        meta: {
          title: 'Welcome',
          meta: [{ name: 'description', content: `Welcome FC Form` }],

          beforeResolve(routeTo, routeFrom, next) {
            //   document.title = 'Welcome'
            if (services.getAuth())
              if (!services.authorized()) next()
              else next({ name: 'session-out' })
            // next()
            else next({ name: 'logout' })
          },
        },
      },
    ],
  },
  {
    path: '/verification',

    name: 'verification',
    component: () => lazyLoadView(import('@views/TheEmailVerification')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (services.getAuth())
          if (!services.authorized()) next({ name: 'logout' })
          else next({ name: 'session-out' })
        // next()
        else next()
      },
    },
  },
  {
    path: '/auth/reset/:uid/:token',
    name: 'reset',
    component: () => lazyLoadView(import('@views/_ForgotPasswordVerification')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (services.getAuth())
          if (!services.authorized()) next({ name: 'logout' })
          else next({ name: 'session-out' })
        // next()
        else next()
      },
    },
  },
  {
    path: '/logout',

    name: 'logout',
    component: () => lazyLoadView(import('@views/logout')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        next()
      },
    },
  },

  {
    path: '/session-out',
    name: 'session-out',
    component: () => lazyLoadView(import('@views/_sessionout')),
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    // loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
